var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarPassThankYouShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8895_3353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9496 29.6256C23.055 29.6256 29.6256 23.055 29.6256 14.9496C29.6256 6.84415 23.055 0.273438 14.9496 0.273438C6.84416 0.273438 0.273438 6.84415 0.273438 14.9496C0.273438 23.055 6.84416 29.6256 14.9496 29.6256Z",
    stroke: "white",
    strokeWidth: 0.457317,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7038 14.9219C29.7038 23.0296 23.1354 29.598 15.0277 29.598C6.91998 29.598 0.351562 23.0296 0.351562 14.9219",
    stroke: "white",
    strokeWidth: 0.457317,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3858 14.9219C24.3858 20.0837 20.1927 24.2769 15.0308 24.2769C9.86894 24.2769 5.67578 20.0837 5.67578 14.9219",
    stroke: "white",
    strokeWidth: 0.457317,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7003 14.9219C19.7003 17.5095 17.6037 19.606 15.0161 19.606C12.4286 19.606 10.332 17.5095 10.332 14.9219",
    fill: "#FF6B35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0012 0.273438H0.97598C0.609548 0.273438 0.3125 0.570486 0.3125 0.936913V28.9621C0.3125 29.3286 0.609548 29.6256 0.97598 29.6256H29.0012C29.3676 29.6256 29.6647 29.3286 29.6647 28.9621V0.936913C29.6647 0.570486 29.3676 0.273438 29.0012 0.273438Z",
    stroke: "white",
    strokeWidth: 0.457317,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8895_3353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 29.9085,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPassThankYouShare);
export default __webpack_public_path__ + "static/media/calendar-pass-thank-you-share.ab8f5820e3920e1af751f95b3b7bf6a2.svg";
export { ForwardRef as ReactComponent };